import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('GridSelect');

function GridSelect(props) {
    const selectOption = (ev, value) => {
        if (props.value !== value) {
            props.onChange(value);
        }
    };

    useEffect(() => {
        if (props.oneSizeLeft) {
            props.onChange(props.oneSizeLeft);
        }
    }, [props.partNumber]);

    const { className, type, name, hasError, options, value } = props;
    const errorClass = hasError ? 'selectWithError' : undefined;

    return (
        <ul className={bem(null, [errorClass, type], className)}>
            {options.map((opt) => {
                const htmlId = `${name}_${opt.key}`;
                return (
                    <li className={bem('optionWrapper')} key={opt.key}>
                        <input
                            className={bem('input')}
                            name={name}
                            type="radio"
                            htmlFor={htmlId}
                            checked={value === opt.value}
                            onChange={(ev) => selectOption(ev, opt.value)}
                        />
                        <label className={bem('optionBox', opt.unavailable && 'unavailable')} id={htmlId} aria-label={opt.descriptiveLabel}>
                            {opt?.onlyOneLeft && <div className={bem('onlyOneMark')} />}
                            {opt.label}
                        </label>
                        {opt.skuMetaData ? <meta itemProp="sku" content={opt.skuMetaData.partNumber} /> : null}{' '}
                        {/* product info for personal shopper chrome extension */}
                    </li>
                );
            })}
        </ul>
    );
}

GridSelect.propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    type: PropTypes.string,
    hasError: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    skus: PropTypes.array.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            key: PropTypes.string,
            label: PropTypes.string || PropTypes.node,
            labelNative: PropTypes.string,
        }),
    ),
};

export default GridSelect;
